/** @format */

// start clients table
export const clientColumn = [
  {
    key: "id",
    headerName: "ID",
  },
  {
    key: "created_at",
    headerName: "تاريخ التسجيل",
  },
  {
    key: "name",
    headerName: "  اسم الكفيل",
    searchable: true,
  },
  { key: "phone", headerName: "رقم الموبايل", width: "10%" },
  { key: "email", headerName: "البريد الالكتروني", searchable: true },
  {
    key: "balance",
    headerName: "الرصيد الكلي",
  },
  {
    key: "status",
    headerName: "الحالة",
    searchable: true,
    options: [{ label: "مفعل" }, { label: "محظور" }],
  },
  {
    key: "setting",
    headerName: "الاجراءات",
  },
];

export const client_orders = [
  {
    key: "id",
    headerName: "رقم الطلب",
  },
  {
    key: "created_at",
    headerName: "تاريخ الطلب",
  },

  { key: "orderName", headerName: "اسم الطلب", width: "10%" },

  {
    key: "status",
    headerName: "حالة الطلب",
  },
  {
    key: "setting",
    headerName: "الاعدادات",
  },
];

// start order history columns
export const HistoryAll = [
  {
    key: "id",
    headerName: "ID",
  },

  { key: "created_at", headerName: "تاريخ الطلب" },
  {
    key: "name",
    headerName: "  اسم الكفيل",
  },
  {
    key: "serviceName",
    headerName: "اسم الخدمة المطلوبة",
  },
  {
    key: "status",
    headerName: "حالة الطلب",
  },
  { key: "total", headerName: " سعر الخدمة" },
  {
    key: "setting",
    headerName: " الاجراءات",
  },
];
export const HistoryWait = [
  { key: "orderNum", headerName: " رقم الطلب" },
  { key: "orderDate", headerName: "تاريخ الطلب " },
  {
    key: "name",
    headerName: "  اسم الكفيل",
  },
  { key: "servicesCategory", headerName: "الخدمات" },
  { key: "serviceName", headerName: "اسم الخدمة المطلوبة" },
];
export const HistorySuccess = [
  {
    key: "serviceName",
    headerName: "اسم الخدمة المطلوبة",
  },
  { key: "serviceCost", headerName: "المبلغ المدفوع" },
  { key: "serviceCost", headerName: "سعر الخدمة" },
  {
    key: "setting",
    headerName: " الاعدادات",
  },
];

// start drivers
export const DriversColumns = [
  { key: "created_at", headerName: "تاريخ الاضافة " },
  {
    key: "id",
    headerName: "كود السائق",
  },
  {
    key: "name",
    headerName: "اسم السائق",
  },
  {
    key: "email",
    headerName: "البريد الالكتروني",
  },
  { key: "phone", headerName: "رقم الموبايل", width: "10%" },

  {
    key: "status",
    headerName: "الحاله",
  },

  {
    key: "setting",
    headerName: "الاعدادات",
  },
];
export const ColumnDriverslastOrder = [
  {
    key: "id",
    headerName: "رقم الطلب",
  },
  { key: "created_at", headerName: "تاريخ الطلب" },
  { key: "serviceData", headerName: "اسم الخدمة المطلوبة" },
  {
    key: "status",
    headerName: "الحاله",
  },
  {
    key: "setting",
    headerName: "الاعدادات",
  },
];
export const ColumnDriversOrders = [
  {
    key: "orders_completed",
    headerName: "عدد الطلبات تمت  ",
  },
  {
    key: "orders_pending",
    headerName: " عدد الطلبات قيد الانتظار  ",
  },
  {
    key: "orders_cancelled",
    headerName: "عدد الطلبات تم الالغاء ",
  },
  { key: "orders_total", headerName: "العدد الكلي للطلبات" },
];
// start service stats

export const ColumnServicesStats = [
  {
    key: "id",
    headerName: "ID",
  },
  {
    key: "name_ar",
    headerName: "اسم الخدمه",
  },
  {
    key: "orders_numbers",
    headerName: "عدد الطلبات",
  },
  // {
  //   key: "servicesPending",
  //   headerName: " عدد الطلبات قيد الانتظار  ",
  // },
  // {
  //   key: "servicesCancel",
  //   headerName: "عدد الطلبات تم الالغاء ",
  // },
  {
    key: "orders_amounts",
    headerName: "المبلغ الناتج من الطلبات  ",
  },
];

//start costs
export const tableCosts = [
  {
    key: "id",
    headerName: "ID",
  },
  { key: "created_at", headerName: "التاريخ " },
  {
    key: "details",
    headerName: "اسم المصروف له",
  },
  { key: "type", headerName: " نوع الصرف" },
  {
    key: "amount",
    headerName: "قيمة الصرف",
  },
  {
    key: "setting",
    headerName: "الاجراءات",
  },
];

//start airports
export const tableAirports = [
  {
    key: "id",
    headerName: "ID",
  },
  {
    key: "name_en",
    headerName: "اسم المطار",
  },
  {
    key: "status",
    headerName: "الحالة",
    // searchable: true,
    options: [{ label: "مفعل" }, { label: "غير مفعل" }],
  },
  {
    key: "setting",
    headerName: "الاجراءات",
  },
];
//start airports
export const tableBanners = [
  {
    key: "banner_type",
    headerName: "نوع الاعلان",
  },
  {
    key: "target",
    headerName: "اللينك",
  },
  {
    key: "status",
    headerName: "الحاله",
  },
  {
    key: "setting",
    headerName: "الاجراءات",
  },
];
//start mangers
export const tableMangers = [
  { key: "addedDate", headerName: "تاريخ الاضافة " },
  // { key: "code", headerName: "كود المشرف" },

  {
    key: "name",
    headerName: "اسم المشرف",
  },

  { key: "phone_number", headerName: "رقم الموبايل", width: "10%" },
  {
    key: "email",
    headerName: "البريد الالكتروني",
  },
  {
    key: "status",
    headerName: "الحاله",
  },

  {
    key: "setting",
    headerName: "الاعدادات",
  },
];
export const ColumnMangerActivity = [
  { key: "code", headerName: "رقم النشاط" },
  { key: "orderDate", headerName: "تاريخ النشاط" },
  {
    key: "name",
    headerName: "اسم المشرف",
  },
  { key: "serviceName", headerName: "نوع النشاط" },

  {
    key: "الاعدادات",
    headerName: "الاعدادات",

    hideActions: true,
  },
];

export const grid = {
  clients: "3% 11% 20% 15% 23% 9% 10% 9%",
  clientOrders: "20% 20% 20% 20% 20%",
  historyAll: "5% 10% 25% 25% 15% 10% 10% ",
  historyWait: "20% 20% 20% 20% 20%",
  historySuccess: "25% 25% 25% 25% ",
  drivers: "15% 15% 15% 15% 15% 15% 15% ",
  airports: "25% 25% 25% 25%",
  banners: "25% 25% 25% 25%",
  serviceStats: "10% 15% 15% 20% 20% 15% ",
  costs: "10% 15% 15% 20% 20% 20%",
  mangers: "10% 15% 15% 20% 20% 20%",
  mangerActivity: "20% 20% 20% 20% 20%",
  driversLastOrders: "20% 20% 20% 20% 20%",
  driversOrders: "20% 20% 20% 20% 20%",
};

export const statusValues = {
  active: "مفعل",
  inactive: "غير مفعل",
  banned: "محظور",
  completed: "تم",
  pending: "قيد الانتظار",
  incomplete: "لم يتم",
  processing: "مقبول",
  cancelled: "ملغي",
};
